import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {
  MDBContainer,
  MDBCol,
  MDBRow
} from "mdb-react-ui-kit";
import "./UserEdit.css";
import { UserEditForm } from "..//UserEditForm/UserEditForm";

export class UserEdit extends React.Component {
  


  render() {
    return  (
    <>
    <Container className="mt-5">
      <Row className="justify-content-md-center">
        <Col md="auto"><h1>Bienvenido a su área personal</h1></Col>
      </Row>
    </Container>
    <MDBContainer>
        <MDBRow className="mt-5">
        <MDBCol size="4">
        </MDBCol>
        <MDBCol size="8">
        <UserEditForm onLoading={(event) => this.props.onLoading(event)}></UserEditForm>
        </MDBCol>
        </MDBRow>
      </MDBContainer>
    </>
    );
  }
}
